import React from "react";
import {
  getLabel,
  getLabelTag,
  getLabelTagInput,
  getLabelTagYesNO,
} from "../constructTextFromValues";
import { builtOptions } from "../../Options/genExamOptions";
import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import SearchIcon from "../../../../assets/images/nurseIcons/search.svg";

const formatGcsEvm = (gcs) => {
  const part = (prefix, value) => {
    if (value === null || value === undefined) return null;
    if (value === "" || value === 0) return null;
    return `${prefix}${value}`;
  };

  const parts = [
    part("E", gcs?.eye_opening_response),
    part("V", gcs?.verbal_response),
    part("M", gcs?.motor_response),
  ].filter(Boolean);

  return parts.length ? parts.join(" ") : null;
};

const PhysiotherapistGeneralExaminationSummary = ({ formData }) => {
  const constructGeneralExaminationSummaryOptions = () => {
    const generalExaminationSummaryItems = [];
    const examination = formData?.general_examination || {};
    const pushGeneralItem = (key, label, children) => {
      generalExaminationSummaryItems.push({ key, label, children });
    };
    if (examination?.built) {
      pushGeneralItem(
        "1",
        "Built",
        <>{getLabelTag(builtOptions, examination?.built)}</>
      );
    }
    if (
      examination?.temperature ||
      examination?.pulse_rate ||
      examination?.respiratory_rate ||
      examination?.systolic_bp ||
      examination?.diastolic_bp ||
      examination?.spo2
    ) {
      pushGeneralItem(
        "2",
        "Vitals at the Time of Admission",
        <>
          {getLabelTagInput("Temperature", examination?.temperature, "°F")}
          {getLabelTagInput("Pulse Rate", examination?.pulse_rate, "beats/min")}
          {getLabelTagInput(
            "Respiratory Rate",
            examination?.respiratory_rate,
            "breaths/min"
          )}
          {getLabelTagInput("Systolic BP", examination?.systolic_bp, "mmHg")}
          {getLabelTagInput("Diastolic BP", examination?.diastolic_bp, "mmHg")}
          {getLabelTagInput("SPO2", examination?.spo2, "%")}
        </>
      );
    }
    if (
      examination?.gcs?.eye_opening_response ||
      examination?.gcs?.verbal_response ||
      examination?.gcs?.motor_response
    ) {
      const evm = formatGcsEvm(examination?.gcs);
      pushGeneralItem(
        "3",
        "Glasgow Coma Scale",
        <>
          {evm ? getLabel(evm) : null}
          {getLabelTagInput("Score", examination?.gcs?.score)}
          {getLabelTagInput("Interpretation", examination?.gcs?.interpretation)}
        </>
      );
    }
    if (examination?.pain_scale || examination?.pain_scale_comments) {
      pushGeneralItem(
        "4",
        "Pain Scale",
        <>
          {getLabelTagYesNO(examination?.pain_scale)}
          {getLabelTagInput("Pain level", examination?.pain)}
          {getLabelTagInput("Interpretation", examination?.pain_interpretation)}
          {getLabelTagInput("Remarks", examination?.pain_scale_comments)}
        </>
      );
    }
    return generalExaminationSummaryItems;
  };
  const generalExaminationSummaryItems =
    constructGeneralExaminationSummaryOptions();
  return (
    <SummaryWrapper
      items={generalExaminationSummaryItems}
      title={
        <Space>
          <Image src={SearchIcon} preview={false} />
          <span style={{ fontWeight: 500 }}>General Examination</span>
        </Space>
      }
    />
  );
};

export default PhysiotherapistGeneralExaminationSummary;
